import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const baseStyles = {
    p: {
        lineHeight: '24px',
        fontSize: (theme: CarrotTheme) => theme.fontSizes.medium,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.normal,
        marginBottom: (theme: CarrotTheme) => theme.space.medium,
    },
};

const p: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
};
export default p;
